export function search() {

    let searchToggle = document.querySelector('.search-toggle');
    let searchForm = document.querySelector('.search-form');
    let searchInput = document.querySelector('.search-input');

    searchToggle.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        searchForm.classList.add('active');
        searchInput.focus();
        document.addEventListener('click', handleSearchClickOutside);
    });

    function handleSearchClickOutside(event) {
        if(! searchForm.contains(event.target)) {
            searchForm.classList.remove('active');
            document.removeEventListener('click', handleSearchClickOutside);
        }
    }
}

